export default __webpack_public_path__ + "static/media/wa-1715.9c04f2c9.jpg";